'use client';

import {useEffect} from 'react';

type Props = {
  error: Error & {digest?: string};
  reset(): void;
};

export default function Error({error, reset}: Props) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div data-component-id="src/app/[locale]/error.tsx:16:4" data-component-path="src/app/[locale]/error.tsx" data-component-line="16" data-component-end-line="24" data-component-file="error.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20min-h-screen%20flex-col%20items-center%20justify-center%20bg-navy-900%20p-4%20text-center%22%7D" className="flex min-h-screen flex-col items-center justify-center bg-navy-900 p-4 text-center">
      <h2 data-component-id="src/app/[locale]/error.tsx:17:6" data-component-path="src/app/[locale]/error.tsx" data-component-line="17" data-component-end-line="17" data-component-file="error.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22mb-4%20text-2xl%20font-bold%20text-white%22%2C%22textContent%22%3A%22Quelque%20chose%20s'est%20mal%20pass%C3%A9%20!%22%7D" className="mb-4 text-2xl font-bold text-white">Quelque chose s'est mal passé !</h2>
      <button data-component-id="src/app/[locale]/error.tsx:18:6" data-component-path="src/app/[locale]/error.tsx" data-component-line="18" data-component-end-line="23" data-component-file="error.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22rounded-xl%20bg-primary-600%20px-6%20py-3%20text-sm%20font-semibold%20text-white%20transition-colors%20hover%3Abg-primary-500%22%2C%22textContent%22%3A%22R%C3%A9essayer%22%7D"
        className="rounded-xl bg-primary-600 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-500"
        onClick={() => reset()}
      >
        Réessayer
      </button>
    </div>
  );
}
